// components/Login.jsx
import React, { useRef } from 'react';
import { Form, Input, Button, Card, Typography, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import useWebPost from '../utils/useWebPost';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const webPost = useWebPost();
  const [form] = Form.useForm();
  const submitRef = useRef(false);

  const onFinish = async (values) => {
    if (submitRef.current) return;
    submitRef.current = true;

    try {
      const ret = await webPost('admlogin', {
        user: values.username.trim(),
        psw: values.password,
      });

      if (ret) {
        // 保存登录信息
        localStorage.setItem('admin', JSON.stringify(ret));
        window['admuser'] = ret;

        // 安全重定向
        let redirectUrl = window['redirectUrl'];
        if (redirectUrl && typeof redirectUrl === 'string') {
          // 只允许内部路由（防止 open redirect 攻击）
          if (!redirectUrl.startsWith('http') && !redirectUrl.includes('login')) {
            delete window['redirectUrl'];
            navigate(redirectUrl);
            submitRef.current = false;
            return;
          }
        }

        navigate('/');
      }
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      submitRef.current = false;
    }
  };

  return (
    <div className='fullscreent'>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '70vh',
        }}
      >
        <Card
          style={{ width: '100%', maxWidth: 500 }}
          bodyStyle={{ padding: '32px 24px' }}
        >
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div style={{ textAlign: 'center' }}>
              <Title level={3} style={{ margin: 0, fontWeight: 600 }}>
                管理员登录
              </Title>
            </div>

            <Form
              form={form}
              name="login"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              size="large"
            >
              <Form.Item
                name="username"
                rules={[{ required: true, message: '请输入用户名' }]}
              >
                <Input
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="用户名"
                  autoFocus
                  autoComplete="username"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码' }]}
              >
                <Input.Password
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="密码"
                  autoComplete="current-password"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={submitRef.current}
                  size="large"
                >
                  登录
                </Button>
              </Form.Item>
            </Form>
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default Login;